import { Expose, Transform, Type } from 'class-transformer';
import { UserEntity } from '@core/entities/user.entity';
import { GroupEntity } from '@core/entities/groups';
import { InitializableEntity } from '@core/entities/_extra/intializable.entity';

export class EmailMessageEntity extends InitializableEntity {
  id: number;

  @Expose({ name: 'sender_id' })
  senderId = '';

  @Expose({ name: 'receiver_id' })
  receiverId: string;

  @Expose({ name: 'esdb_id' })
  esDbId: string;
  type = 'text';
  owner: string;
  kind = '';

  @Expose({ name: 'kind_id' })
  kindId = 0;

  @Expose({ name: 'is_read' })
  isRead: number;

  @Expose({ name: 'approved_status' })
  approvedStatus: number;

  @Expose({ name: 'created_at' })
  createdAt: string;
  column: string;

  @Expose({ name: 'file_details' })
  fileDetails: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  content = '';

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  subject = '';

  attachments: string;
  cc: string[] = [];
  to: string[] = [];

  // For POST/PUT Request
  @Expose({ name: 'message_type' })
  messageType = '';

  // For Ui purpose
  @Type(() => UserEntity)
  ccUsers: UserEntity[];

  @Type(() => UserEntity)
  toUsers: UserEntity[];

  @Type(() => EmailUserEntity)
  user: EmailUserEntity;

  @Type(() => GroupEntity)
  group?: GroupEntity;

  attachmentUrl: string | URL | RequestInfo;
  isAttachmentImage: boolean;

  constructor(init?: Partial<EmailMessageEntity>) {
    super();
    this.initEntity(init);
  }
}

export class EmailUserEntity {
  guest: boolean;
  id: string;
  firstName: string;
  lastName: string;

  @Expose({ name: 'club_id' })
  clubId: string;
  email: string;

  @Expose({ name: 'fcmtoken' })
  fcmToken: string;

  username: string;

  @Expose({ name: 'member_id' })
  memberId: string;

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
